module.exports = hasKeys

function hasKeys(source) {
    return source !== null &&
        (typeof source === "object" ||
        typeof source === "function")
}



//////////////////
// WEBPACK FOOTER
// ./~/level-ws/~/xtend/has-keys.js
// module id = 1494
// module chunks = 0 1 2